module.exports = __webpack_public_path__ + "img/red_car.586fa152.png";